import colors from 'vuetify/lib/util/colors'

export default {
  primary: {
    base: '#58D0D6',
    lighten1: '#F2E7FE',
    lighten2: '#DBB2FF',
    lighten3: '#BB86FC',
    lighten4: '#FFFBA4',
    lighten5: '#DBEEBA',
    lighten6: '#FFFFC2',
    darken1: '#35BDD6',
    darken2: '#30A0BD',
    darken3: '#1B6396',
    darken4: '#224277',
    darken5: '#3B3C3A'    
  },
  secondary: {
    base: '#03DAC5',
    lighten1: '#C8FFF4',
    lighten2: '#DBB2FF',
    lighten3: '#00C4B4',
    lighten4: '#00B3A6',
    darken1: '#FBE375',
    darken2: '#FFE25E',
    darken3: '#FFDD41',
    darken4: '#FFD71E',
    darken5: '#F3C800'
  },
  onPrimary: {
    base: '#57D1D7',
    darken1: '#000000',
    lighten1: '#FFFFFF',
    lighten2: '#D4F2F4',
    lighten3: '#98E2E6',
    lighten4: '#FCFCFC'
  }, 
  onSecondary: {    
    lighten1: '#AAAAAA',    
    lighten2: '#9F9F9F',    
    lighten3: '#727272',    
  },   
  accent: colors.blue.accent1,
  error: colors.red.accent2,
  info: colors.blue,
  success: colors.green,
  warning: colors.amber,
  anchor: colors.blue.darken2
}
